/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const confirmResetPasswordBodyPasswordMin = 12;

export const ConfirmResetPasswordBody = zod
	.object({
		password: zod.string().min(confirmResetPasswordBodyPasswordMin).describe('New password'),
		password_confirmation: zod.string().describe('Password confirmation')
	})
	.describe('Reset password request body');

export type ConfirmResetPasswordBody = zod.input<typeof ConfirmResetPasswordBody>;
export type ConfirmResetPasswordBodyOutput = zod.output<typeof ConfirmResetPasswordBody>;
